
import React from 'react';

const Services: React.FC = () => {
  return (
    <section id="services" className="py-24 bg-stone-100 border-y border-stone-200">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif font-bold text-stone-900">The Benchmarks of Style</h2>
          <p className="text-red-800 mt-4 uppercase tracking-[0.3em] font-bold text-sm">Clean. Precise. Professional.</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main Service Description */}
          <div className="lg:col-span-2 bg-white p-12 shadow-xl border-t-8 border-stone-800 flex flex-col justify-center">
            <h3 className="text-3xl font-serif italic font-bold text-stone-800 mb-6">Expertise You Can Trust</h3>
            <div className="space-y-4 text-stone-600 leading-relaxed font-serif text-lg">
              <p>
                At Norm’s, we specialize in the full spectrum of barbering. From the Sharpest fades to the most disciplined military cuts, we take pride in the details that define a great look.
              </p>
              <p>
                We don't follow a rigid menu—we follow your lead. If it can be mastered with clippers and shears, we have the experience to get it right the first time.
              </p>
            </div>
          </div>

          {/* Service List */}
          <div className="bg-stone-900 text-white p-10 flex flex-col justify-center shadow-xl">
            <h4 className="font-bold uppercase tracking-widest text-stone-500 mb-8 text-xs border-b border-stone-800 pb-4">Our Specialties</h4>
            <ul className="space-y-6 font-serif text-xl">
              <li className="flex items-center space-x-3 group">
                <span className="w-1.5 h-6 bg-red-700 block"></span>
                <span className="group-hover:translate-x-1 transition-transform">Regular & Traditional</span>
              </li>
              <li className="flex items-center space-x-3 group">
                <span className="w-1.5 h-6 bg-white block"></span>
                <span className="group-hover:translate-x-1 transition-transform">Contemporary Styles</span>
              </li>
              <li className="flex items-center space-x-3 group">
                <span className="w-1.5 h-6 bg-blue-700 block"></span>
                <span className="group-hover:translate-x-1 transition-transform">Precision Fades</span>
              </li>
              <li className="flex items-center space-x-3 group">
                <span className="w-1.5 h-6 bg-red-700 block"></span>
                <span className="group-hover:translate-x-1 transition-transform">Flattops & Military</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Closing CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block p-8 border-2 border-dashed border-stone-300">
            <p className="text-2xl font-serif italic text-stone-800 mb-4">"Everyone is welcome in our chair."</p>
            <p className="text-stone-500 uppercase tracking-widest font-bold text-sm">Walk-ins are always welcome. Stop in today.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
